module.exports = __webpack_public_path__ + "img/bonus_symbol_0.d84f8584.png";